<template>
  <v-dialog
  v-model="visible"
  max-width="8000px"
  persistent
  fullscreen
  light
  transition="dialog-bottom-transition"
  :overlay="false"
  scrollable>

  <v-card>
    <v-toolbar style="flex: 0 0 auto;" dark color="green">
      <v-btn icon v-on:click="close()" dark>
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>{{teamName}}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-container fluid >
        <v-layout row wrap>
          <v-flex xs12 :key="player.id" v-for="(player, i) in currentPlayersOfTeam">
            <player-card :number="i+1" :teamId="teamId" :player="player" />
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>

  </v-card>

</v-dialog>
</template>

<script>
import PlayerCard from './PlayerCard'
import { mapActions, mapGetters } from 'vuex'
export default {
    components: {
      PlayerCard
    },
    name: 'PlayersOfTeam',
    props: {
        teamId: { required: true },
        teamName: {default: ""}
    },
    data() {
        return {
          player: null

        }
    },
    created() {

    },
    mounted(){

    },
    watch:{
      teamId(val){
        console.log("teamId",val)
        if(val){
          let data = {
            tournamentId:this.currentTournament.id,
            teamId: val
          }
          this.loadPlayersOfTeam(data)
        }
      }
    },
    computed:{
      visible(){
        return this.teamId != null
      },
      validateBtn(){
        return this.player && (this.player.status_in_tournament == "pending" || this.player.status_in_tournament == "rejected")
      },
      rejectBtn(){
        return this.player && (this.player.status_in_tournament == "pending" || this.player.status_in_tournament == "accepted")
      },
      requireValidation(){
        return this.currentTournament.team_type == 1 && this.currentTournament.team_approval
      },
      ...mapGetters([
        "currentTournament",
        "currentPlayersOfTeam"
      ])
    },
    methods: {
      ...mapActions([
        "loadPlayersOfTeam",
        "resolvePlayerOfficialInfo",
        "currentTournament"
      ]),
      close(){
        this.$emit('close')
      },
      resolve(status){
        let data = {}
        data.playerId = this.player.id
        data.status = status
        data.tournamentId = this.currentTournament.id
        this.resolvePlayerOfficialInfo(data)
        this.close()
      }
    }
}
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/tournaments/teams/PlayersOfTeam.vue